import { createSelector } from 'reselect';
import { userAccountSelector, accountAuthorizationsSelector } from '../../account/store/selectors';
import { evaluateAuthRequireAll } from '../../authorizations/auth-helpers';
import { AUTHORIZATIONS } from '../../authorizations/authorizations';
import { siteSportSelector } from '../../site/store/selectors';

import isEmpty from 'lodash/isEmpty';
const { CAN_EDIT_SITES, CAN_EDIT_USERS, CAN_MANAGE_VIDEO_SERVICE } = AUTHORIZATIONS;
const EMPTY_ARRAY = [];
const EMPTY_OBJECT = [];

const baseAppCoreLoadedSelector = ({ account, app }) => {
    return account.validateCheckComplete && app.availableAuthSitesLoaded;
};

export const isMobile = ({ app }) => app.isMobile;

// required for sport routing. Possible we can rework that a bit but not sure how
// maybe something like "siteSports" on the user validation object
export const siteTemplatesLoaded = createSelector(
    userAccountSelector,
    accountAuthorizationsSelector,
    ({ site }) => !isEmpty(site?.templates),
    (account, authorizations, siteTemplatesLoaded) =>
        account.validateCheckComplete &&
        (!authorizations.includes(CAN_EDIT_SITES) || siteTemplatesLoaded)
);

export const appCoreLoadedSelector = createSelector(
    baseAppCoreLoadedSelector,
    siteTemplatesLoaded,
    (baseCoreLoaded, siteCoreLoaded) => {
        return baseCoreLoaded && siteCoreLoaded;
    }
);

export const availableAuthSitesFiltersSelector = ({ app }) => app.authSiteFilters || EMPTY_OBJECT;

const baseAvailableAuthSitesSelector = ({ app }) => app.availableAuthSites || EMPTY_ARRAY;

export const availableAuthSitesSelector = createSelector(
    baseAvailableAuthSitesSelector,
    userAccountSelector,
    (availableAuthSites, userAccount) => {
        return availableAuthSites.map((site) => {
            // if the site has authorizations then use those, otherwise use the authorizations for the user
            if (site?.authorizations) {
                return site;
            }
            return {
                ...site,
                authorizations: userAccount?.authorizations,
            };
        });
    }
);

// activeAuthSite from the user selectors is not used here to prevent circular ref.. maybe some of those types of crossover selectors should be pulled out of user
export const authorizedNavRoutesSelector = createSelector(
    userAccountSelector,
    accountAuthorizationsSelector,
    ({ user }) => user?.activeAuthSite,
    siteSportSelector,
    (userAccount, userAuthorizations, activeAuthSiteName, siteSport) => {
        const userRouteName = activeAuthSiteName ? 'user-landing' : 'auth-site-list';
        const possibleRoutes = [
            {
                name: userRouteName,
                displayKey: 'Users',
                data: { authSite: activeAuthSiteName },
                authRequirements: {
                    authRequireAll: [CAN_EDIT_USERS],
                },
            },
            {
                name: 'site-list',
                displayKey: 'Sites',
                data: { sport: siteSport },
                authRequirements: {
                    authRequireAll: [CAN_EDIT_SITES],
                },
            },
            {
                name: 'video-service-list',
                displayKey: 'Video Service',
                authRequirements: {
                    authRequireAll: [CAN_MANAGE_VIDEO_SERVICE],
                },
            },
        ];
        if (userAccount.validateCheckComplete) {
            return possibleRoutes.filter((r) =>
                evaluateAuthRequireAll(r?.authRequirements?.authRequireAll, userAuthorizations)
            );
        }
        return EMPTY_ARRAY;
    }
);
